import React, { useState, useEffect } from 'react';
import { AxiosError } from 'axios';
import { useParams } from 'react-router-dom';
import { Invoice } from '../../models/invoice.model';
import { CustomAxios } from '../../redux/axios/axios';

export const useInvoice = (
  setErrorMessage: React.Dispatch<React.SetStateAction<string | undefined>>
) => {
  const { id } = useParams();
  const [invoice, setInvoice] = useState<Invoice>();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');
    const locationId = searchParams.get('locationId');
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        'Location-Id': locationId,
      },
    };

    CustomAxios.get(`invoices/${id}`, config)
      .then((response) => {
        setInvoice(response.data.data);
      })
      .catch((error: AxiosError) => {
        console.error(error);
        setErrorMessage('Error loading invoice');
      });
  }, [id, setErrorMessage]);

  return invoice;
};
